<template>
  <div class="statuses">
    <template v-for="(name, index) in statuses" :key="index">
      <el-tag size="small" type="primary" effect="dark" v-if="Number(index) === modelValue">{{ name }}</el-tag>
      <el-tag size="small" type="info" effect="plain" v-else>{{ name }}</el-tag>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Statuses',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    statuses: {
      type: Object,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 2px;
  margin-bottom: 2px;
  border-radius: 20px;
}
.statuses {
  margin-left: -5px;
  margin-right: -5px;
}
</style>
